// nextfe's page for one artifact, the address jiri-web links a delivered file by. Its `/download` and `/frame`
// are not the page.
const ARTIFACT_PAGE_PATH = /^\/artifacts\/([A-Za-z0-9]+)\/*$/

const ARTIFACT_TOKEN = /^[A-Za-z0-9]+$/

function parseUrl(url: string): URL | null {
  try {
    return new URL(url)
  } catch {
    return null
  }
}

function withAuthToken(url: string, authToken: string | null | undefined): string {
  return authToken ? `${url}?m_t=${encodeURIComponent(authToken)}` : url
}

/** The token of a nextfe artifact page on `baseUrl`'s origin, or null for any other address. */
export function artifactPageToken(url: string, baseUrl: string | undefined): string | null {
  const address = parseUrl(url)
  const base = baseUrl ? parseUrl(baseUrl) : null
  if (!address || !base || address.origin !== base.origin) return null
  return ARTIFACT_PAGE_PATH.exec(address.pathname)?.[1] ?? null
}

/**
 * The page to load for an artifact token. Built from the token alone: a clicked link's own query is not trusted,
 * and the App's login rides along as `m_t` because the WebView shares no cookie with nextfe.
 */
export function artifactPageUrl(token: string, baseUrl: string, authToken: string | null | undefined): string {
  return withAuthToken(`${baseUrl}/artifacts/${encodeURIComponent(token)}`, authToken)
}

/** The file behind an artifact token, built like `artifactPageUrl`; null when `token` is not an artifact token. */
export function artifactDownloadUrl(
  token: unknown,
  baseUrl: string | undefined,
  authToken: string | null | undefined
): string | null {
  if (!baseUrl || typeof token !== 'string' || !ARTIFACT_TOKEN.test(token)) return null
  return withAuthToken(`${baseUrl}/artifacts/${token}/download`, authToken)
}
